export default class Counter {
  /**
   * 
   * @param counter {HTMLElement} <div class="wp-counter">
   * @param visibility {number} 1-100
   * 
  */
  constructor(counter, visibility) {

    this.element = counter;
    this.locale = 'en-US';
    this.separator = '.';
    this.title = this.element.querySelector('.wp-counter__title');
    this.limit = parseInt(this.element.getAttribute('data-number'));
    this.visibility = (typeof visibility === 'number' && visibility > 0 && visibility <= 100) ? (100 - visibility) / 100 : 1;
    this.isActive = this.isActive.bind(this);

    window.addEventListener('scroll', this.isActive);
    window.addEventListener('resize', this.isActive);
    this.isActive();
  }

  isActive() {

    const rect = this.element.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    const windowWidth = window.innerWidth || document.documentElement.clientWidth;

    const elementHeight = rect.bottom - rect.top;
    const elementWidth = rect.right - rect.left;

    const isVisible = (
      rect.top + (elementHeight * this.visibility) >= 0 &&
      rect.left + (elementWidth * this.visibility) >= 0 &&
      rect.bottom - (elementHeight * this.visibility) <= windowHeight &&
      rect.right - (elementWidth * this.visibility) <= windowWidth
    );

    if (isVisible 
        && !this.element.classList.contains('finished')
        && !this.element.classList.contains('started')
      ) {
      this.element.classList.add('active');
      this.startCount()
    } else {
      this.element.classList.remove('active');
    }
  }

  startCount() {
    let count = 0;
    const increment = this.getIncrement();
    this.element.classList.add('started');
    
    const interval = setInterval(() => {
      
      const formattedCount = count.toLocaleString(this.locale);

      if (count <= this.limit) {
        this.title.textContent = formattedCount.replace(/,/g, this.separator);
        count += increment;
      } else {
        clearInterval(interval);
        if (count !== this.limit) {
          const formattedLimit = this.limit.toLocaleString(this.locale);
          this.title.textContent = formattedLimit.replace(/,/g, this.separator);
          this.element.classList.add('finished');
          this.element.classList.remove('started');
        }
      }
    }, 50);
  }

  getIncrement() {
    if (this.limit < 5000) {
      return 303;
    } else if (this.limit <= 10000) {
      return 534;
    } else if (this.limit < 1000000) {
      return 3234;
    } else {
      return 1234567;
    }
  }




}